import { FilteredComponentSystemUpdateEntityArgs } from '@common/systems/SystemBase';

import { ClientRegistry } from '../components';
import { ClientFilteredComponentSystem } from './ClientBase';

/**
 * Updates the MovementMode of the local player based on Input.sneak.
 * Used for client-side prediction of speed changes.
 */
export class ClientPlayerMovementModeSystem extends ClientFilteredComponentSystem {
  public componentClasses: (keyof ClientRegistry)[] = ['PlayerControlled', 'Input', 'MovementMode'];
  protected simulationBound = true;
  protected override localPlayerOnly = true;
  protected override skipDeadEntities = true;

  updateEntity({ world, entityId }: FilteredComponentSystemUpdateEntityArgs<ClientRegistry>): void {
    const input = world.getComponent(entityId, 'Input')!;
    const movementMode = world.getComponent(entityId, 'MovementMode')!;

    const targetMode = input.sneak ? 'walk' : 'run';

    if (movementMode.mode !== targetMode) {
      this.updateComponent(entityId, movementMode, { mode: targetMode });
    }
  }
}
